// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "header-1X6t_";
var _4 = "vizaWrapper-3oIjA";
export { _1 as "__esModule", _2 as "mobile", _3 as "header", _4 as "vizaWrapper" }
export default { "__esModule": _1, "mobile": _2, "header": _3, "vizaWrapper": _4 }
